import enumeration from "./enumeration";

const VoucherStatus = {
  Active: "ACTIVE",
  Inactive: "INACTIVE",
  Expired: "EXPIRED",
};

export default enumeration(VoucherStatus);
